import Vue from 'vue';
import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import '../admin/public/bootstrap';
import LoadScript from '@common/components/LoadScript.vue';
import Counter from '@common/components/Counter.vue';
import Navigation from '../application/javascript/navigation';
import dropcap from '../application/javascript/dropcap';
import MapComponent from '../application/javascript/MapComponent.vue';
import CampMap from '../application/javascript/CampMap.vue';
import BeigeMap from '../application/javascript/BeigeMap.vue';
import hasState from '../application/javascript/has-state.vue';
import Toc from '../application/javascript/Toc.vue';
import Swiper from '../application/javascript/Swiper.vue';

require('../styles/application.scss');
require('../../assets/stylesheets/application.scss');

Rails.start();
Turbolinks.start();

Vue.component('load-script', LoadScript);
Vue.component('counter', Counter);
Vue.component('photo-gallery', () => import('../application/javascript/PhotoGallery.vue'));
Vue.component('navigation', Navigation);
Vue.component('map-component', MapComponent);
Vue.component('camp-map', CampMap);
Vue.component('beige-map', BeigeMap);
Vue.component('has-state', hasState);
Vue.component('toc', Toc);
Vue.component('swiper', Swiper);

let vueApp;

// dropcap();

// Bootstrap the Vue root instance
document.addEventListener('turbolinks:load', () => {
  vueApp = new Vue({ el: '#js-wrapper' });
});

document.addEventListener('turbolinks:visit', () => {
  if (vueApp) vueApp.$destroy();
});


